// extracted by mini-css-extract-plugin
module.exports = {"cell":"style-module_cell__vfwP0Mxa0dtr0alGj9Yb"};